import { request } from './http';

const updateReservationAdminConfig = (payload) => request('updateReservationAdminConfig', {
  body: payload,
  authRequired: true
});

const getCloverWebhookStatus = () => request('getCloverWebhookStatus', {
  authRequired: true
});

export { updateReservationAdminConfig, getCloverWebhookStatus };
